import { useMemo } from 'react';
import {
  createExtension,
  coreExtensionData,
  createExtensionInput,
  useApi,
} from '@backstage/frontend-plugin-api';
import { routeResolutionApiRef, NavItemBlueprint } from '@backstage/frontend-plugin-api';
import { CustomNavBar } from '../components/CustomNavBar';

export const CustomAppNav = createExtension({
  name: 'nav',
  attachTo: { id: 'app/layout', input: 'nav' },
  inputs: {
    items: createExtensionInput([NavItemBlueprint.dataRefs.target]),
  },
  output: [coreExtensionData.reactElement],
  factory({ inputs }) {
    const NavRenderer = () => {
      const routeResolutionApi = useApi(routeResolutionApiRef);

      const navItems = useMemo(() => {
        console.log('Nav items from plugins:', inputs.items.length);
        return inputs.items
          .map((input) => {
            const target = input.get(NavItemBlueprint.dataRefs.target);

            if (!target.routeRef) {
              console.warn(`No routeRef for ${target.title}`);
              return null;
            }

            const link = routeResolutionApi.resolve(target.routeRef);

            if (!link) {
              console.warn(`Unable to resolve route ref for ${target.title}`);
              return null;
            }

            return {
              title: target.title,
              to: link(),
              icon: target.icon,
            };
          })
          .filter((item): item is NonNullable<typeof item> => item !== null);
      }, [inputs.items, routeResolutionApi]);

      return <CustomNavBar navItems={navItems} />;
    };

    return [coreExtensionData.reactElement(<NavRenderer />)];
  },
});
